import {
  Base3Number,
  Decimals,
  Field,
  FieldAccessMeta,
  FieldAccessMetaInBase3,
  FieldObjectSubType,
} from 'module/api/field/types';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';

const NUMBER_OF_FIELD_IN_SINGLE_DECIMAL = 25;

export const decimalToBase3Array = (
  decimal: number,
  expectedLength: number = NUMBER_OF_FIELD_IN_SINGLE_DECIMAL,
): Base3Number[] =>
  Array.from(decimal.toString(3).padStart(expectedLength, '0'), (x) =>
    Number(x),
  ).reverse();
export const decimalsToBase3Array = (decimals: Decimals): Base3Number[] =>
  decimals.reduce(
    (result, decimal) => result.concat(decimalToBase3Array(decimal)),
    [] as Base3Number[],
  );

export const fieldAccessMetaToBase3 = (
  fieldAccessMeta: Partial<FieldAccessMeta>,
): FieldAccessMetaInBase3 => {
  return Object.entries(fieldAccessMeta).reduce(
    (base3Map, [objectType, decimals]) => {
      base3Map[objectType] = decimalsToBase3Array(decimals);

      return base3Map;
    },
    {} as FieldAccessMetaInBase3,
  );
};

export const hasReadAccessForField = (
  field: Field | FilterableField,
  accessMeta?: FieldAccessMetaInBase3,
): boolean => {
  if (accessMeta == null) {
    return false;
  }
  const { objectType } = field as Field;

  if (field.fieldIndex == null || objectType == null) {
    return true;
  }

  return accessMeta[objectType]?.[field.fieldIndex] !== 0;
};
export const hasWriteAccessForField = (
  field: Field | FilterableField,
  accessMeta?: FieldAccessMetaInBase3,
): boolean => {
  if (accessMeta == null) {
    return false;
  }
  const { objectType, objectSubType } = field as Field;

  if (field.fieldIndex == null || objectType == null) {
    return true;
  }

  const accessMetaKey =
    (objectSubType !== FieldObjectSubType.Default && objectSubType) ||
    objectType;

  return accessMeta[accessMetaKey]?.[field.fieldIndex] === 2;
};
